import React from "react";
import { FaLinkedin, FaTwitter, FaGlobe } from "react-icons/fa";
import team1 from "../assets/team/lohit.jpg";
import team2 from "../assets/team/kunal.jpg";
const TeamSection = React.memo(() => {
  const teamMembers = [
    {
      name: "Lohitaksh Nandan",
      role: "Co-Founder & CEO",
      image: team1,
      social: {
        linkedin: "https://www.linkedin.com/in/lohitakshnandan",
        x: "https://www.x.com/NandanLohitaksh", 
      },
    },
    {
      name: "Kunal Das",
      role: "Co-Founder & CTO",
      image: team2,
      social: {
        linkedin: "https://www.linkedin.com/in/kunal-das-5qe23",
        x: "https://x.com/kunal_da5",
        portfolio: "https://kunaldas.vercel.app",
      },
    },
  ];

  const teamSectionStyle = {
    width: "100%",
    padding: "80px 20px",
    background: "rgba(17, 17, 17, 0.9)",
    color: "#fff",
    textAlign: "center",
    position: "relative",
    overflow: "hidden",
    marginBottom: "0",
  };

  const teamContentStyle = {
    maxWidth: "1200px",
    margin: "0 auto",
    position: "relative",
    zIndex: 1,
  };

  const teamHeadingStyle = {
    fontSize: "2.5rem",
    marginBottom: "40px",
    fontFamily: "'Monomakh', sans-serif",
  };

  const teamGridStyle = {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "center",
    gap: "80px",
    marginBottom: "0",
  };

  const teamCardStyle = {
    position: "relative",
    width: "300px",
    height: "400px",
    overflow: "hidden",
    border: "2px solid #03dac6",
    borderRadius: "10px",
    cursor: "pointer",
    transition: "transform 0.3s ease",
  };

  const teamCardImgStyle = {
    width: "100%",
    height: "100%",
    objectFit: "cover",
    display: "block",
    borderRadius: "10px",
  };

  const teamOverlayStyle = {
    position: "absolute",
    bottom: 0,
    left: 0,
    right: 0,
    background: "rgba(43, 44, 44, 0.9)",
    color: "#03dac6",
    padding: "20px",
    opacity: 0,
    transition: "opacity 0.3s ease",
    textAlign: "center",
  };

  const socialLinksStyle = {
    marginTop: "10px",
    display: "flex",
    justifyContent: "center",
    gap: "15px",
  };

  const socialIconStyle = {
    color: "#555",
    fontSize: "3rem",
    textDecoration: "none",
    transition: "color 0.3s ease, filter 0.3s ease",
  };

  const SocialIcon = ({ href, children }) => {
    const [hovered, setHovered] = React.useState(false);
    return (
      <a
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        style={{
          ...socialIconStyle,
          color: hovered ? "#03dac6" : socialIconStyle.color,
          filter: hovered ? "drop-shadow(0 0 10px #03dac6)" : "none",
        }}
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
      >
        {children}
      </a>
    );
  };

  const TeamCard = ({ member }) => {
    const [isHovered, setIsHovered] = React.useState(false);

    const cardStyle = {
      ...teamCardStyle,
      transform: isHovered ? "translateY(-5px)" : "translateY(0)",
    };

    const overlayStyle = {
      ...teamOverlayStyle,
      opacity: isHovered ? 1 : 0,
    };

    return (
      <div
        style={cardStyle}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <img
          src={member.image}
          alt={member.name}
          style={teamCardImgStyle}
          loading="lazy"
        />
        <div style={overlayStyle}>
          <h3>{member.name}</h3>
          <p>{member.role}</p>
          <div style={socialLinksStyle}>
            <SocialIcon href={member.social.linkedin}>
              <FaLinkedin />
            </SocialIcon>
            <SocialIcon href={member.social.x}>
                 <FaTwitter />
            </SocialIcon>
            {member.social.portfolio && (
              <SocialIcon href={member.social.portfolio}>
                <FaGlobe />
              </SocialIcon>
            )}
          </div>
        </div>
      </div>
    );
  };

  const ViewAllButton = () => {
    const [hovered, setHovered] = React.useState(false);
    const btnStyle = {
      display: "inline-block",
      marginTop: "40px",
      padding: "10px 20px",
      fontSize: "1rem",
      fontFamily: "'Rubik', sans-serif",
      color: hovered ? "#000" : "#03dac6",
      border: "2px solid #03dac6",
      borderRadius: "5px",
      textDecoration: "none",
      transition: "transform 0.3s ease, boxShadow 0.3s ease, background 0.3s ease",
      background: hovered ? "#03dac6" : "transparent",
      transform: hovered ? "scale(1.05)" : "scale(1)",
      boxShadow: hovered ? "0 0 15px #03dac6" : "none",
    };

    return (
      <a
        href="/TeamSection"
        style={btnStyle}
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
      >
        View All
      </a>
    );
  };

  return (
    <section style={teamSectionStyle}>
      <div style={teamContentStyle}>
        <h2 style={teamHeadingStyle}>The People behind!</h2>
        <div style={teamGridStyle}>
          {teamMembers.map((member, index) => (
            <TeamCard key={index} member={member} />
          ))}
        </div>
        <ViewAllButton />
      </div>
    </section>
  );
});

export default TeamSection;
